import { put, takeLatest, all } from "redux-saga/effects";
import { api, nodeApi, exportApi } from "../../service/apiService";
import {
	getSubscriptionKey,
	getAccessDetail,
	getSource,
	getTemplates,
	getReasonCode,
	getStatusGrid,
	getNoOfRecipient,
	getTemplateContent,
	getSaveRequest,
	getSaveTemplate,
	getEditTemplate,
	getSendForApproval,
	getRequestDetails,
	getAppoversGrid,
	getAssignToMe,
	getApproveOrDecline,
	getUseTemplateContent,
	getDownloadDl,
	saveDl,
	getSearchResultCurrent,
	sendMassEmail,
	scheduleMassEmail,
	cancelCurrRequest,
	deleteRequest,
	getHelpDeskMessagesUrl,
	deleteMessageUrl,
	createMessageUrl,
	getDivision,
	updateMessageUrl,
	getArchiveMessagesUrl,
	activateArchiveMessagesUrl,
	getMessageTypesUrl,
} from "../../service/apiUrls";

// import { formSelectDataA } from "utils/utils";

import { authTokenCookie } from "../../utils/CookieMaker";
import { userRole } from "../../utils/constants";
import { serviceInProgress } from "../../component/containers/loader/LoaderAction";
import {
	setRole,
	GET_ROLE,
	GET_APIMKEY,
	setAPIMKey,
	GET_ACCESSDETAILS,
	setAccessDetails,
	GET_NOOFRECIPIENT,
	GET_REASONCODE,
	GET_URGENCY,
	GET_TEMPLATE,
	GET_SOURCE,
	setSource,
	setNoOfRecipient,
	setReasonCode,
	setTemplate,
	setUrgency,
	setStatusGrid,
	GET_STATUSGRID,
	GET_TEMPLATECONTENT,
	setTemplateContent,
	GET_SAVEREQUEST,
	setSaveRequest,
	GET_EDITTEMPLATE,
	GET_SAVETEMPLATE,
	setSaveTemplate,
	// setEditTemplate,
	GET_SENDFORAPPROVAL,
	setSendForApproval,
	GET_REQUESTDETAILS,
	setRequestDetails,
	GET_APPROVERSGRID,
	GET_ASSIGNTOME,
	setAssignToMe,
	setApproverGrid,
	GET_APPROVEORDECLINE,
	setApproveOrDecline,
	GET_USETEMPLATECONTENT,
	setUseTemplateContent,
	DOWNLOAD_DL,
	GET_TEMPALTEDLLIST,
	setTemplateDlList,
	SAVE_DL,
	SEND_MASS_EMAIL,
	SCHEDULE_MASS_EMAIL,
	CANCEL_REQUEST,
	setFileUploadErrMsg,
	GET_DELETE_REQUEST,
	setDeleteRequest,
	setEditTemplate,
	setCancelledError,
} from "../../component/screens/massMailer/massMailerAction";

import {
	GET_MESSAGES,
	setMessages,
	getMessages,
	DELETE_MESSAGE,
	ADD_MESSAGE,
	GET_DIVISION,
	// setDivision,
	openDeleteSuccessPopup,
	deletePopUpStatusMsg,
	openSubmitSuccessPopup,
	createNewMessagePopUpStatusMsg,
	fetchDivisionOptions,
	EDIT_MESSAGE_REQUEST,
	setArchiveMessages,
	GET_ARCHIVE_MESSAGES_REQUEST,
	ACTIVATE_MESSAGE_REQUEST,
	activateMessageSuccess,
	openActivatePopup,
	activatePopUpStatusMsg,
	getArchiveMessagesRequest,
	fetchMessageTypesSuccess,
	FETCH_MESSAGE_TYPES_REQUEST,
	setPageNoHelpDesk,
	setPageSizeHelpDesk,
	setTotalPagesHelpDesk,
	setTotalRecordsHelpDesk,
	// closeModal,
} from "../../component/containers/helpDesk/helpDeskActions";

import {
	setMassEmailData,
	setScheduleMassEmailData,
	setDlSaveStatus,
	setRequestId,
	setUseTemplateStatus,
	setRequestCanceled,
} from "component/containers/mmSendMassEmailReqDetails/mmSendMassEmailReqDetailsAction";
import { call, select } from "redux-saga/effects";
import * as selectors from "./selectors";

import { serviceError } from "../../common/ServiceError/ServiceErrorAction";
// import { setApprovalReqData } from 'component/containers/mmApprovalReqDetails/mmApprovalReqDetailsAction';

function exceptionFormatter(exp) {
	console.log(exp, "Exception catch");
	if (exp.config) {
		return {
			message:
				"System is unable to process this request at the moment, please retry after some time.",
		};
	} else return { exp, url: ``, method: `` };
}

function isJWTNotExpired() {
	let tokenNotExpired = true;
	let currentDate = new Date();
	let currentTime = currentDate.getTime();
	let { decodedIdToken, authCookie, userInfo } = authTokenCookie();
	// JWT exp is in seconds
	let sessionId = sessionStorage.getItem("sessionId");
	if (authCookie.name && sessionId === userInfo.userId) {
		let tokenExpiry = decodedIdToken.exp * 1000;
		if (tokenExpiry < currentTime) {
			tokenNotExpired = false;
		}
	}
	return tokenNotExpired;
}

function* get_SubKey() {
	try {
		let response = yield call(() => {
			return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
		});
		// let response = yield call(() => { return nodeApi(`https://svwp-ctl-ui-dev.apps.np.stratus.albertsons.com/api/getSubKey`,`GET`) });
		let key = response && response.data && response.data.subKey;
		yield put(setAPIMKey(key));
	} catch (exp) {
		console.log(`APIM Key exception`, exp);
	}
}

function* get_Role() {
	try {
		yield put(serviceInProgress(true));
		const data = userRole;
		yield put(setRole(data));
		yield put(serviceInProgress(false));
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* get_AccessDetails(userInfo) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			// JWTExpirationCheck();
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let request = {
				userNameRole: userInfo?.value?.allUserRole?.join(`;`),
				userName: userInfo?.value?.userId,
			};

			// let res = yield call(() => { return api(getAccessDetail.url, getAccessDetail.method, request, subKey) })
			let res = yield call(() => {
				return api(
					getAccessDetail.url,
					getAccessDetail.method,
					request,
					subKey
				);
			});
			yield put(setAccessDetails(res?.data));
			authTokenCookie(res?.data?.allAppDet);
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* get_StatusGrid(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getStatusGrid.url}?requestorGroup=${req.value}`,
					getStatusGrid.method,
					"",
					subKey
				);
			});
			yield put(setStatusGrid(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_Source() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(`${getSource.url}`, getSource.method, "", subKey);
			});
			yield put(setSource(data?.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_ReasonCode() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(`${getReasonCode.url}`, getReasonCode.method, "", subKey);
			});
			yield put(setReasonCode(data?.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_Template() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(`${getTemplates.url}`, getTemplates.method, "", subKey);
			});
			yield put(setTemplate(data?.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_NoOfRecipient(file) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getNoOfRecipient.url}`,
					getNoOfRecipient.method,
					file?.value,
					subKey
				);
			});
			yield put(setNoOfRecipient(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		if (exp && exp.response.status === 400) {
			yield put(setFileUploadErrMsg(exp.response.data.message));
		} else {
			yield put(serviceError(exceptionFormatter(exp)));
		}
		yield put(serviceInProgress(false));
	}
}
function* get_Urgency() {
	try {
		let data = [
			{
				id: "0",
				value: "Not Urgent",
			},
			{
				id: "1",
				value: "Urgent",
			},
		];
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			// let subKey = yield select(selectors.key);
			// let url = getTemplateContent.url + "/Custom_IT_SSETH11_121322"
			// let data1 = yield call(() => { return api(`${url}`, getTemplateContent.method, '', subKey) })
			yield put(setUrgency(data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_TemplateContent(templateName) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let url = getTemplateContent.url + "/" + templateName.value;
			let data = yield call(() => {
				return api(`${url}`, getTemplateContent.method, "", subKey);
			});
			yield put(setTemplateContent(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_SaveRequest(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getSaveRequest.url}`,
					getSaveRequest.method,
					req.value,
					subKey
				);
			});
			yield put(setSaveRequest(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_SaveTemplate(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let url =
				getSaveTemplate.url +
				"/" +
				req?.value?.templateName +
				"?username=" +
				req?.value?.userId;
			let data = yield call(() => {
				return api(
					`${url}`,
					getSaveTemplate.method,
					req?.value?.request,
					subKey
				);
			});
			yield put(setSaveTemplate(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_EditTemplate(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getEditTemplate.url}/${req.tempId}`,
					getEditTemplate.method,
					req.value,
					subKey
				);
			});
			yield put(setEditTemplate(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* get_SendForApproval(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getSendForApproval.url}`,
					getSendForApproval.method,
					req.value,
					subKey
				);
			});
			yield put(setSendForApproval(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_RequestDetails(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);

			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}

			let url = getRequestDetails.url + "/" + req?.value;
			let data = yield call(() => {
				return api(`${url}`, getRequestDetails.method, "", subKey);
			});
			yield put(setRequestDetails(data.data));
			// // // // // // // // console.log(
			// // // // // // // // "🚀 ~ file: index.js:392 ~ function*get_RequestDetails ~ data",
			// // // // // // // // data
			// // // // // // // // );
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_ApproversGrid(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getAppoversGrid.url}`,
					getAppoversGrid.method,
					"",
					subKey
				);
			});
			yield put(setApproverGrid(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_AssignToMe(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let url =
				getAssignToMe.url +
				"/" +
				req?.value.username +
				"/" +
				req?.value.requestId +
				"?name=" +
				req?.value.name;
			let data = yield call(() => {
				return api(`${url}`, getAssignToMe.method, "", subKey);
			});
			yield put(setAssignToMe(data.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
function* get_ApproveOrDecline(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let url = `${getApproveOrDecline.url}/${req?.reqId}/action`;
			let data = yield call(() => {
				return api(`${url}`, getApproveOrDecline.method, req.value, subKey);
			});
			let resp = {
				...data.data,
				status: 200,
				msg: `Thanks for reviewing the Mass Mailer request. Related approver comments and status has been communicated to the respective Mass Mailer user.`,
			};

			yield put(setApproveOrDecline(resp));
			yield put(serviceInProgress(false));
		}
	} catch (err) {
		if (err && err.response.status) {
			let resp = {
				status: err.response.status,
				msg: `Currently we are unable to process your request. Please try after sometime.`,
			};
			yield put(setApproveOrDecline(resp));
			yield put(serviceInProgress(false));
		}
	}
}

function* get_TemplateDlList(reqObj) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let url = getSearchResultCurrent.url;
			let reqBody = {
				templateName: reqObj.value.templateName,
				requestId: reqObj.value.requestId,
				pageNumber: reqObj.PageNo,
				sizePage: reqObj.RowCount,
				sortBy: reqObj.SortBy,
				fieldName: reqObj.FieldName,
			};

			let subKey = yield select(selectors.key);

			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}

			let dataTest = yield call(() => {
				return api(url, getSearchResultCurrent.method, reqBody, subKey);
			});

			yield put(setTemplateDlList(dataTest.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* sendMassEmailData(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let url = sendMassEmail.url;

			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let dataTest = yield call(() => {
				return api(url, sendMassEmail.method, req.value, subKey);
			});
			if (dataTest.status === 200) {
				yield put(setMassEmailData(1, "Mass email has been sent successfully"));
				yield put(serviceInProgress(false));
			} else {
				yield put(
					setMassEmailData(
						2,
						"Mass email has not been sent due to system error, please retry after sometime."
					)
				);
				yield put(serviceInProgress(false));
			}
		}
	} catch (err) {
		let message = "";
		switch (err && err.response.status) {
			case 409:
				message = err.response.data.errorList[0];
				yield put(setMassEmailData(2, message));
				break;
			case 403:
				message = err.response.data.errorList[0];
				yield put(setMassEmailData(2, message));
				break;
			case 404:
				message = `Mass email has not been sent due to system error, please retry after sometime.`;
				yield put(setMassEmailData(2, message));
				break;
			case 500:
				message = `Mass email has not been sent due to system error, please retry after sometime.`;
				yield put(setMassEmailData(2, message));
				break;
			case 400:
				message = `Mass email has not been sent due to system error, please retry after sometime.`;
				yield put(setMassEmailData(2, message));
				break;
			default:
				yield put(serviceError(exceptionFormatter(err)));
				break;
		}

		yield put(serviceInProgress(false));
	}
}

function* sendScheduleMassEmailData(req) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let url = scheduleMassEmail.url;

			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let dataTest = yield call(() => {
				return api(url, scheduleMassEmail.method, req.value, subKey);
			});
			if (dataTest.status === 200) {
				yield put(
					setScheduleMassEmailData(
						1,
						"Mass email has been scheduled successfully"
					)
				);
				yield put(serviceInProgress(false));
			} else {
				yield put(
					setScheduleMassEmailData(
						2,
						"Mass email has not been scheduled due to system error, please retry after sometime."
					)
				);
				yield put(serviceInProgress(false));
			}
		}
	} catch (err) {
		let message = "";
		switch (err && err.response.status) {
			case 409:
				message = err.response.data.errorList[0];
				yield put(setScheduleMassEmailData(2, message));
				break;
			case 403:
				message = err.response.data.errorList[0];
				yield put(setScheduleMassEmailData(2, message));
				break;
			case 404:
				message = `Mass email has not been scheduled due to system error, please retry after sometime.`;
				yield put(setScheduleMassEmailData(2, message));
				break;
			case 500:
				message = `Mass email has not been scheduled due to system error, please retry after sometime.`;
				yield put(setScheduleMassEmailData(2, message));
				break;
			case 400:
				message = `Mass email has not been sent due to system error, please retry after sometime.`;
				yield put(setScheduleMassEmailData(2, message));
				break;
			default:
				yield put(serviceError(exceptionFormatter(err)));
				break;
		}
		yield put(serviceInProgress(false));
	}
}

function* getUseTemplateContentData(requestData) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			// let url = getUseTemplateContent.url + "/" + requestData.value + "/" + 1
			let url =
				getUseTemplateContent.url +
				"/" +
				requestData?.value?.templateDropdownValue +
				"/" +
				requestData?.value?.source?.split(`-`)[0];
			let data = yield call(() => {
				return api(
					`${url}`,
					getUseTemplateContent.method,
					{ templateName: requestData.value },
					subKey
				);
			});
			if (data.status === 200) {
				yield put(setUseTemplateContent(data.data));
				yield put(setUseTemplateStatus(1));
			}
			// console.log(
			// "🚀 ~ function*getUseTemplateContentData ~ data.data:",
			// data.data
			// );

			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* download_Dl() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let dataTest = yield call(() => {
				return exportApi(getDownloadDl.url, getDownloadDl.method, ``, subKey);
			});
			// yield put(setAllSearchResult(dataTest))
			if (dataTest.status === 200) {
				var blob = new Blob([dataTest.data], { type: "application/xlsx" });
				var link = document.createElement("a");
				var fileURL = window.URL.createObjectURL(blob);
				link.href = fileURL;
				link.download = `Mass Email upload template.xlsx`;
				link.target = "_blank";
				link.click();
				yield put(serviceInProgress(false));
				return true;
			}
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* cancel_Request(requestData) {
	try {
		let url =
			cancelCurrRequest.url +
			`/${requestData.requestId}/cancel?userId=${requestData.userId}&name=${requestData.name}`;
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));

			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let dataTest = yield call(() => {
				return exportApi(url, cancelCurrRequest.method, ``, subKey);
			});

			if (dataTest.status === 200) {
				yield put(serviceInProgress(false));
				yield put(setRequestCanceled(1));
				yield put(
					setCancelledError("info", `Template is successfully deleted.`)
				);
				//
			}
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(
			setCancelledError(
				"error",
				`Request completed. Request cannot be deleted.`
			)
		);
	}
}
function* delete_Request(requestData) {
	try {
		let url =
			deleteRequest.url +
			`/${requestData.templateId}?userId=${requestData.userId}&name=${requestData.name}`;
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));

			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let dataTest = yield call(() => {
				return exportApi(url, deleteRequest.method, ``, subKey);
			});
			yield put(setDeleteRequest(dataTest.data));
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* save_Dl(requestData) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));

			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(saveDl.url, saveDl.method, requestData.payload, subKey);
			});

			if (data.status === 200) {
				yield put(setRequestId(data.data));
				yield put(setDlSaveStatus(1));
				yield put(setSaveRequest(data.data));
			}
			// console.log("🚀 ~ function*save_Dl ~ data.data:", data.data);
			// console.log("🚀 ~ function*save_Dl ~ data.data:", data.data);
			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

//! HelpDesk Calls start
function* get_division() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);

			if (subKey === undefined) {
				// JWTExpirationCheck();
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.dashboardSubKey;
			}

			let dataTest = yield call(() => {
				return api(getDivision.url, getDivision.method, ``, subKey);
			});
			// let data;
			// if (dataTest) {
			// 	data = formSelectDataA("Select Division", dataTest.data);
			// }
			// // // // // // // // console.log("🚀 ~ function*get_division ~ data:", data);
			// yield put(fetchDivisionOptions(data));
			yield put(fetchDivisionOptions(dataTest.data));

			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* get_HelpDeskMessages() {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			// let messages = [
			// 	{
			// 		serialNumber: 1,
			// 		messageType: "Info",
			// 		message: "This is a test message 1",
			// 		createdBy: "User1",
			// 		dateTime: "2022-01-01 10:00:00",
			// 	},
			// 	{
			// 		serialNumber: 2,
			// 		messageType: "Warning",
			// 		message: "This is a test message 2",
			// 		createdBy: "User2",
			// 		dateTime: "2022-01-02 11:00:00",
			// 	},
			// 	{
			// 		serialNumber: 3,
			// 		messageType: "Error",
			// 		message: "This is a test message 3",
			// 		createdBy: "User3",
			// 		dateTime: "2022-01-03 12:00:00",
			// 	},
			// 	{
			// 		serialNumber: 4,
			// 		messageType: "Info",
			// 		message: "This is a test message 4",
			// 		createdBy: "User4",
			// 		dateTime: "2022-01-04 13:00:00",
			// 	},
			// ];

			// const reqBody = {
			// 	pageNumber: 1,
			// 	sizePage: 100,
			// 	sortOrder: "asc",
			// };

			//!uncomment
			let data = yield call(() => {
				return api(
					`${getHelpDeskMessagesUrl.url}`,
					getHelpDeskMessagesUrl.method,
					`req`,
					subKey
				);
			});
			// // // // // // // console.log("🚀 ~ fetched messages :", data);
			// yield put(setMessages(messages));
			yield put(setMessages(data.data)); //! uncomment

			yield put(serviceInProgress(false));
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

// get Archive Messages
function* get_ArchiveMessages(reqBody) {
	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			const body = {
				pageNumber: reqBody?.payload?.pageNumber,
				sizePage: reqBody?.payload?.pageSize,
				sortOrder: reqBody?.payload?.sortOrder,
			};
			let data = yield call(() => {
				return api(
					`${getArchiveMessagesUrl.url}`,
					getArchiveMessagesUrl.method,
					body,
					subKey
				);
			});
			yield put(setArchiveMessages(data?.data));

			yield put(setPageNoHelpDesk(data?.data?.pageNumber));
			yield put(setPageSizeHelpDesk(data?.data?.sizePage));
			yield put(setTotalPagesHelpDesk(data?.data?.totalPages));
			yield put(setTotalRecordsHelpDesk(data?.data?.totalSize));

			yield put(serviceInProgress(false));
			// // console.log("🚀 ~ function*get_ArchiveMessages ~ data.data:", data?.data);
		}
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}
// Delete HelpDesk Message Saga
function* delete_HelpDeskMessages(action) {
	try {
		let url = `${deleteMessageUrl.url}/${action.payload}`;
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));

			let subKey = yield select(selectors.key);
			console.log("Initial subKey: ", subKey); // Debugging log
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				console.log("Response from getSubscriptionKey: ", response); // Debugging log
				subKey = response && response.data && response.data.subKey;
			}
			let deleteResponse = yield call(() => {
				return api(url, deleteMessageUrl.method, ``, subKey);
			});
			console.log("Response from deleteMessage: ", deleteResponse); // Debugging log
			if (deleteResponse.status === 200) {
				yield put(getMessages("req"));
				//yield put(getArchiveMessagesRequest());
				yield put(getArchiveMessagesRequest(1, 5, "asc"));
				// yield put(setMessages(deleteResponse.data));
				yield put(openDeleteSuccessPopup());
				yield put(deletePopUpStatusMsg(deleteResponse?.data));
				yield put(serviceInProgress(false));
			} else {
				yield put(openDeleteSuccessPopup());
				yield put(
					deletePopUpStatusMsg(
						"Message could not be archived.Please try again."
					)
				);
				yield put(serviceInProgress(false));
			}
		}
	} catch (exp) {
		console.log("Error in delete_HelpDeskMessages: ", exp); // Debugging log
		yield put(openDeleteSuccessPopup());
		yield put(deletePopUpStatusMsg("Message delete unsuccessful"));
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

// Create HelpDesk Message Saga
function* create_HelpDeskMessage(action) {
	try {
		let url = createMessageUrl.url;
		console.log("URL: ", url); // Debugging log
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);
			console.log("Initial subKey: ", subKey); // Debugging log
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				console.log("Response from getSubscriptionKey: ", response); // Debugging log
				subKey = response && response.data && response.data.subKey;
			}
			// // // // // // // // console.log("🚀 ~ createResponse ~ message to post :", action.payload);
			let createResponse = yield call(() => {
				return api(url, createMessageUrl.method, action.payload, subKey);
			});

			// yield put(closeModal()); //! re test later
			console.log("Response from createMessage: ", createResponse); // Debugging log
			// yield put(setCreateResponse(createResponse.data));

			if (createResponse.status === 200) {
				yield put(
					createNewMessagePopUpStatusMsg(
						"The message has been successfully submitted."
					)
				);
				yield put(getMessages("req"));
				yield put(getArchiveMessagesRequest(1, 5, "asc"));
				yield put(serviceInProgress(false));
				yield put(openSubmitSuccessPopup());
			} else {
				yield put(
					createNewMessagePopUpStatusMsg(
						"The message submission was unsucuessful. Please try again."
					)
				);
				yield put(serviceInProgress(false));
			}
			// setTimeout(()=>	yield put(openSubmitSuccessPopup())	, 5000);
		}
	} catch (exp) {
		console.log("Error in create_HelpDeskMessage: ", exp); // Debugging log
		yield put(
			createNewMessagePopUpStatusMsg(
				"Error. The message submission was unsucuessful. Please try again."
			)
		);

		yield put(serviceInProgress(false));
		yield put(getMessages("req")); //! fot testing
		yield put(getArchiveMessagesRequest(1, 5, "asc"));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

//! Edit HelpDesk Message Saga
function* edit_HelpDeskMessage(action) {
	try {
		let url = updateMessageUrl.url + `/${action.payload.serialNumberToEdit}`;
		// // // // // // // console.log("🚀 ~ function*edit_HelpDeskMessage ~ action:", action);
		// // // // // // // console.log("🚀 ~ function*edit_HelpDeskMessage ~ url:", url);
		// deleteRequest.url +
		// 	`/${requestData.templateId}?userId=${requestData.userId}&name=${requestData.name}`;
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);
			console.log("Initial subKey: ", subKey); // Debugging log
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				console.log("Response from getSubscriptionKey: ", response); // Debugging log
				subKey = response && response.data && response.data.subKey;
			}
			// // // // // // // // console.log("🚀 ~ editResponse ~ message to update :", action.payload);
			const reqBody = {
				message: action?.payload?.message,
			};
			let editResponse = yield call(() => {
				return api(url, updateMessageUrl.method, reqBody, subKey);
			});

			console.log("Response from editMessage: ", editResponse); // Debugging log

			if (editResponse.status === 200) {
				yield put(
					createNewMessagePopUpStatusMsg(
						"The message has been successfully updated."
					)
				);
				yield put(getMessages("req")); //!need to do get call for all messages?
				yield put(getArchiveMessagesRequest(1, 5, "asc"));
				yield put(serviceInProgress(false));
				yield put(openSubmitSuccessPopup());
			} else {
				// yield put(
				// 	createNewMessagePopUpStatusMsg(
				// 		"The message update was unsuccessful. Please try again."
				// 	)
				// );
				yield put(serviceInProgress(false));
			}
		}
	} catch (exp) {
		console.log("Error in edit_HelpDeskMessage: ", exp); // Debugging log
		// yield put(
		// 	createNewMessagePopUpStatusMsg(
		// 		"Error. The message update was unsuccessful. Please try again."
		// 	)
		// );
		// yield put(openSubmitSuccessPopup());
		yield put(serviceInProgress(false));
		yield put(getMessages("req")); //! for testing
		yield put(getArchiveMessagesRequest(1, 5, "asc"));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* activateMessageSaga(action) {
	// // // // // // // console.log("🚀 ~ function*activateMessageSaga ~ action:", action);
	try {
		let url = `${activateArchiveMessagesUrl.url}/${action.payload.serialNumber}`;
		console.log("URL: ", url); // Debugging log
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));

			let subKey = yield select(selectors.key);
			console.log("Initial subKey: ", subKey); // Debugging log
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				console.log("Response from getSubscriptionKey: ", response); // Debugging log
				subKey = response && response.data && response.data.subKey;
			}
			let activateResponse = yield call(() => {
				return api(url, activateArchiveMessagesUrl.method, ``, subKey);
			});
			console.log("Response from activateMessage: ", activateResponse); // Debugging log
			if (activateResponse.status === 200) {
				yield put(getMessages("req"));
				yield put(getArchiveMessagesRequest(1, 5, "asc"));
				yield put(activateMessageSuccess(activateResponse.data));
				yield put(openActivatePopup());
				yield put(activatePopUpStatusMsg("Message successfully activated"));
				yield put(serviceInProgress(false));
			} else {
				yield put(openActivatePopup());
				yield put(
					activatePopUpStatusMsg("Message activation failed. Please try again.")
				);
				yield put(serviceInProgress(false));
			}
		}
	} catch (exp) {
		console.log("Error in activateMessageSaga: ", exp); // Debugging log
		// yield put(openActivateSuccessPopup());
		// yield put(activatePopUpStatusMsg("Message activation unsuccessful"));
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* fetchMessageTypesSaga() {
	// // // // // // // console.log(
	// // // // // // // "🚀 ~ function*fetchMessageTypesSaga ~ fetchMessageTypesSaga:",
	// // // // // // // fetchMessageTypesSaga
	// // // // // // // );

	try {
		if (isJWTNotExpired()) {
			yield put(serviceInProgress(true));
			yield put(serviceError(""));
			let subKey = yield select(selectors.key);
			if (subKey === undefined) {
				let response = yield call(() => {
					return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method);
				});
				subKey = response && response.data && response.data.subKey;
			}
			let data = yield call(() => {
				return api(
					`${getMessageTypesUrl.url}`,
					getMessageTypesUrl.method,
					"",
					subKey
				);
			});
			// // // // // // // console.log("🚀 ~ fetched message types :", data);
			yield put(fetchMessageTypesSuccess(data.data));

			yield put(serviceInProgress(false));
		}
		// console.log("🚀 ~ function*fetchMessageTypesSaga ~ data.data:", data.data);
	} catch (exp) {
		yield put(serviceInProgress(false));
		yield put(serviceError(exceptionFormatter(exp)));
	}
}

function* Watcher() {
	yield takeLatest(GET_APIMKEY, get_SubKey);
	yield takeLatest(GET_ACCESSDETAILS, get_AccessDetails);
	yield takeLatest(GET_ROLE, get_Role);
	yield takeLatest(GET_STATUSGRID, get_StatusGrid);
	yield takeLatest(GET_SOURCE, get_Source);
	yield takeLatest(GET_TEMPLATE, get_Template);
	yield takeLatest(GET_REASONCODE, get_ReasonCode);
	yield takeLatest(GET_URGENCY, get_Urgency);
	yield takeLatest(GET_NOOFRECIPIENT, get_NoOfRecipient);
	yield takeLatest(GET_TEMPLATECONTENT, get_TemplateContent);
	yield takeLatest(GET_SAVEREQUEST, get_SaveRequest);
	yield takeLatest(GET_SAVETEMPLATE, get_SaveTemplate);
	yield takeLatest(GET_EDITTEMPLATE, get_EditTemplate);
	yield takeLatest(GET_SENDFORAPPROVAL, get_SendForApproval);
	yield takeLatest(GET_REQUESTDETAILS, get_RequestDetails);
	yield takeLatest(GET_APPROVERSGRID, get_ApproversGrid);
	yield takeLatest(GET_ASSIGNTOME, get_AssignToMe);
	yield takeLatest(GET_APPROVEORDECLINE, get_ApproveOrDecline);
	yield takeLatest(GET_TEMPALTEDLLIST, get_TemplateDlList);
	yield takeLatest(SEND_MASS_EMAIL, sendMassEmailData);
	yield takeLatest(SCHEDULE_MASS_EMAIL, sendScheduleMassEmailData);
	yield takeLatest(GET_USETEMPLATECONTENT, getUseTemplateContentData);
	yield takeLatest(DOWNLOAD_DL, download_Dl);
	yield takeLatest(SAVE_DL, save_Dl);
	yield takeLatest(CANCEL_REQUEST, cancel_Request);
	yield takeLatest(GET_DELETE_REQUEST, delete_Request);
	yield takeLatest(GET_MESSAGES, get_HelpDeskMessages);
	yield takeLatest(DELETE_MESSAGE, delete_HelpDeskMessages);
	yield takeLatest(ADD_MESSAGE, create_HelpDeskMessage);
	yield takeLatest(GET_DIVISION, get_division);
	yield takeLatest(EDIT_MESSAGE_REQUEST, edit_HelpDeskMessage);
	yield takeLatest(GET_ARCHIVE_MESSAGES_REQUEST, get_ArchiveMessages);
	yield takeLatest(ACTIVATE_MESSAGE_REQUEST, activateMessageSaga);
	yield takeLatest(FETCH_MESSAGE_TYPES_REQUEST, fetchMessageTypesSaga);
}
// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
	yield all([Watcher()]);
}
